/* eslint-disable max-len */
import { useDispatch, useSelector } from "react-redux";

import { IRootState } from "../../../state";
import { hospitalDetailsListActions } from "../../../state/hospital-list-details";
import { ILocationItemResponse } from "../../../services/edit-hospital-location/edit-hospital-location.interface";

// store created to handle storing of getMetrolocations api response
// to restrict reduntant api calls

export const useHospitalDetailsListStore = () => {
  const dispatch = useDispatch();
  const {
    hospitalDetailsList,
    currentLocation,
    isHospitalListUpdated,
  } = useSelector((state: IRootState) => state.hospitalDetailsList);

  const setHospitalList = (data: ILocationItemResponse[]) => {
    dispatch(hospitalDetailsListActions.setHospitalList(data));
  };
  const setCurrentLocation = (data: string) => {
    dispatch(hospitalDetailsListActions.setCurrentLocation(data));
  };

  // function to check if the hospital details store was updated
  const setIsHospitalListUpdated = (data: boolean) => {
    dispatch(hospitalDetailsListActions.setIsHospitalListUpdated(data));
  };


  return {
    hospitalDetailsList,
    currentLocation,
    isHospitalListUpdated,
    setHospitalList,
    setCurrentLocation,
    setIsHospitalListUpdated,
  };
};
